const hljs = require("highlight.js");
export default require("markdown-it")({
  highlight: function(str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(lang, str).value;
      } catch (__) {
        return null;
      }
    }

    return ""; // use external default escaping
  },
  html: true
});
